<template>
  <div class="asc-advanced-custom-alerts-rec-action--wrapper">
    <asc-tooltip
      :tooltip-length="100"
      :tooltip="isDataBricksRunning ? tooltipMsg : ''"
      :left="true"
    >
      <asc-rich-text-input
        :key="recAction"
        :max-length="3500"
        :comment="recAction"
        placeholder="Write your recommended action..."
        :can-edit="!isDataBricksRunning || !isReadOnly"
        :hidden-menu="!isReadOnly"
        :disabled="isDataBricksRunning || isReadOnly"
        @updated="handleUpdatedText"
      ></asc-rich-text-input>
      <p class="recActionmsg">{{ getRecommendedActionMessage }}</p>
    </asc-tooltip>
    <asc-validation-message
      v-if="isValidRecAction"
      message="Please enter a recommended action."
      :show="true"
    />
  </div>
</template>

<script>
import AscRichTextInput from '@/components/atoms/AscRichTextInput'
import AscLabel from '@/components/atoms/AscLabel'
import AscValidationMessage from '@/components/atoms/AscValidationMessage'
import AscTooltip from '@/components/atoms/AscTooltip'

export default {
  name: 'AscAdvancedCustomAlertsRecActionWrapper',

  components: {
    AscRichTextInput,
    AscLabel,
    AscValidationMessage,
    AscTooltip,
  },

  props: {
    tooltipMsg: {
      type: String,
      default: '',
    },
    isDataBricksRunning: {
      type: Boolean,
      default: false,
    },
    alertData: {
      type: Object,
      default: () => {},
    },
    isValidRecAction: {
      type: Boolean,
      default: true,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {}
  },

  computed: {
    getRecommendedActionMessage() {
      return 'This will display as recommended action within each newly generated maintenance recommendation.'
    },

    recAction: {
      get() {
        return this.alertData?.recAction
      },
      set(val) {
        this.$emit('handleChangeRecAction', val)
        this.$emit('isDirty')
      },
    },
  },

  methods: {
    handleUpdatedText(text) {
      this.recAction = text
    },
  },
}
</script>

<style lang="scss">
.asc-advanced-custom-alerts-rec-action--wrapper {
  margin-top: 16px;
}
.recActionmsg {
  color: $gray-600;
}
</style>
